module.exports = __webpack_public_path__ + "img/135_thumbnail.9e4f07ec.jpg";